import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-muted" }

import SideMenuInfo
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuInfo.vue";
import {__} from "~/ts/library/Translate";
import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";


import {ref} from 'vue';

let clientInfoCollapsed = ref(false);

const __default__ = {
    name: "ClientAnalyticCounters"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    site: {}
  },
  setup(__props: any) {

let props = __props;


return (_ctx: any,_cache: any) => {
  return (!__props.site.isFree && __props.userdata.analyticCounters.length > 0)
    ? (_openBlock(), _createBlock(SideMenuCard, {
        key: 0,
        class: "info",
        collapsed: _unref(clientInfoCollapsed),
        "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event: any) => (_isRef(clientInfoCollapsed) ? (clientInfoCollapsed).value = $event : clientInfoCollapsed = $event))
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(__)('Счётчики')), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userdata.analyticCounters, (platform) => {
            return (_openBlock(), _createBlock(SideMenuInfo, {
              key: platform.id,
              icon: {
                fontAwesomeIcon: platform.icon,
                color: platform.color,
                imgIcon: platform.iconImg
            }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(platform.descr), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platform.data, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key
                  }, _toDisplayString(item.key) + ": " + _toDisplayString(item.value), 1))
                }), 128))
              ]),
              _: 2
            }, 1032, ["icon"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["collapsed"]))
    : _createCommentVNode("", true)
}
}

})